import React, { useState } from 'react';

export const PrimaryButton = (props: {
  text: string;
  isLoading?: boolean;
  onclick: () => any;
  isDisabled?: boolean;
}) => {
  return (
    <button
      className={props.isDisabled ? "bg-theLighterDark w-full p-3 rounded-lg font-medium text-white text-opacity-80 bg-opacity-20" : "bg-primaryViolet w-full p-3 rounded-lg font-medium text-white"}
      onClick={() => (props.isDisabled || props.isLoading ? console.log('') : props.onclick())}
    >
      {props.text}{' '}
      {props.isLoading === true ? (
        <div className="spinner-border animate-spin inline-block w-4 h-4 border-2 rounded-full ml-2" role="status" />
      ) : (
        <></>
      )}
    </button>
  );
};
